export default {
  common: {
    welcomeToGravy: 'Welcome to Gravy',
    send: 'Send',
    yes: 'Yes',
    no: 'No'
  },
  ref: {
    endorse: 'Endorse your colleague!',
    complete: 'Your answers has been saved!',
    supervisor: {
      q1: 'Is _worker_ eligible for rehire?',
      q2: 'Did _worker_ make any lateral moves or receive and promotions while working for you?',
      q3: 'Did _worker_ do the bare minimum required for his/her job or go above and beyond?',
      q4: 'Was _worker_ ever disciplined for tardiness or absenteeism?',
      q5: 'On a scale of 1 – 10 how would you judge _worker_ conflict resolution skills?',
      q6: 'On a scale of 1 – 10 how would you judge _worker_ leadership skills?',
      q7: 'On a scale of 1 – 10 how would you judge _worker_ customer engagement skills?',
      q8: 'On a scale of 1 – 10 how would you judge _worker_ ability to communicate effectively in writing (emails, memos, etc.)',
      q9: 'On a scale of 1 – 10 how would you judge _worker_ ability to professionally represent himself through verbal and non-verbal communication?'
    },
    coWorker: {
      q1: 'Was _worker_ a pleasure to work with?',
      q2: 'Did _worker_ do the bare minimum required for his/her job or go above and beyond?',
      q3: 'Was _worker_ a worker that believed in team work?',
      q4: 'On a scale of 1 – 10 how would you judge _worker_ conflict resolution skills?',
      q5: 'On a scale of 1 – 10 how would you judge _worker_ leadership skills?',
      q6: 'On a scale of 1 – 10 how would you judge _worker_ customer engagement skills?',
      q7: 'On a scale of 1 – 10 how would you judge _worker_ ability to communicate effectively in writing (emails, memos, etc.)',
      q8: 'On a scale of 1 – 10 how would you judge _worker_ ability to professionally represent himself through verbal and non-verbal communication?'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/translations/en.js